//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'

export default Vue.extend({
  name: 'ShiftIcon',
  props: {
    fillColor: {
      type: String,
      required: false,
      default: '',
    },
  },
})
